import type { RefCallback } from 'react';
import { Link } from '@tanstack/react-router';
import { AppLogo } from '@/components/common/AppLogo';
import { AppWordmark } from '@/components/common/AppWordmark';
import { cn } from '@/lib/utils';
import { MobileNav } from './MobileNav';
import { COMPACT_LOGO_CLASS, COMPACT_WORDMARK_CLASS } from './sidebar.constants';
import { UserMenu } from './UserMenu';

const HEADER_CLASS = cn(
  'group/app-header sticky top-0 z-40 flex h-app-header items-center gap-2 px-4 md:gap-4 md:px-app-gutter-x',
  'border-b border-sidebar-border bg-sidebar',
);

interface AppHeaderProps {
  titleSlotRef: RefCallback<HTMLDivElement>;
  actionsSlotRef: RefCallback<HTMLDivElement>;
}

export function AppHeader({ titleSlotRef, actionsSlotRef }: AppHeaderProps) {
  return (
    <header className={HEADER_CLASS}>
      <MobileNav />
      <Link
        to="/"
        className="flex items-center gap-2 md:hidden group-has-[[data-slot=app-header-title]>*]/app-header:hidden"
      >
        <AppLogo className={COMPACT_LOGO_CLASS} />
        <AppWordmark className={COMPACT_WORDMARK_CLASS} />
      </Link>
      <div
        ref={titleSlotRef}
        data-slot="app-header-title"
        className="flex min-w-0 flex-1 items-center"
      />
      <div
        ref={actionsSlotRef}
        data-slot="app-header-actions"
        className="hidden shrink-0 items-center gap-2 lg:flex"
      />
      <UserMenu />
    </header>
  );
}
